import { ParamMap } from '@angular/router';
import { todayIso } from './date-only';

/** The calendar days a Raporty tab covers, both inclusive, "YYYY-MM-DD". */
export interface ReportRange {
  from: string;
  to: string;
}

// Both Raporty tabs read one range from the URL as ?from=YYYY-MM-DD&to=YYYY-MM-DD (0092, 0118).
// Without parameters a tab opens on the first day of the current month to today, and the URL is
// rewritten to say so, so a copied link always names the days it shows
export function parseRange(params: ParamMap): ReportRange {
  const today = todayIso();
  const from = parseDay(params.get('from')) ?? `${today.slice(0, 8)}01`;
  const to = parseDay(params.get('to')) ?? today;

  // od after do cannot be picked (the do input's min is od), but a pasted link can say it:
  // the range then starts and ends on od
  return { from, to: to < from ? from : to };
}

export function sameRange(a: ReportRange, b: ReportRange): boolean {
  return a.from === b.from && a.to === b.to;
}

// a real calendar day or nothing — 2026-02-31 reads as absent
function parseDay(value: string | null): string | undefined {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return undefined;
  }

  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
    ? value
    : undefined;
}
